'use strict';

module.exports = {
    defaultSettings: {
        dots: false,
        infinite: false,
        mobileFirst: true,
        arrows: true,
        adaptiveHeight: true
    },
    pdpImageCarousel: {
        selector: '.variation-simple .primary-images .carousel.main',
        settings: {
            infinite: false,
            slidesToShow: 1,
            dots: true,
            fade: true,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: globalConfig.bp.large,
                    settings: {
                        asNavFor: '.variation-simple .primary-images .carousel.thumbnails',
                        touchMove: false,
                        swipeToSlide: false,
                        swipe: false,
                        dots: false,
                        arrows: false
                    }
                }
            ]
        }
    },
    pdpProductSetImageCarousel: {
        selector: '.set-item .primary-images .carousel.main',
        settings: {
            infinite: false,
            slidesToShow: 1,
            dots: true,
            fade: true,
            slidesToScroll: 1
        }
    },
    pdpImageThumbnailsCarousel: {
        selector: '.variation-simple .primary-images .carousel.thumbnails',
        settings: {
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: '.variation-simple .primary-images .carousel.main',
            variableWidth: true,
            focusOnSelect: true
        }
    },
    bundleImageCarousel: {
        selector: '.product-detail.bundle .primary-images .carousel.main',
        settings: {
            infinite: false,
            slidesToShow: 1,
            dots: true,
            fade: true,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: globalConfig.bp.large,
                    settings: {
                        asNavFor: '.product-detail.bundle .primary-images .carousel.thumbnails',
                        dots: false,
                        arrows: false
                    }
                }
            ]
        }
    },
    bundlepdpImageThumbnailsCarousel: {
        selector: '.product-detail.bundle .primary-images .carousel.thumbnails',
        settings: {
            infinite: false,
            slidesToShow: 4,
            slidesToScroll: 1,
            asNavFor: '.product-detail.bundle .primary-images .carousel.main',
            variableWidth: true,
            focusOnSelect: true
        }
    },
    editModalImageCarousel: {
        selector: '#edickViewModal .primary-images .carousel.main',
        settings: {
            infinite: false,
            slidesToShow: 1,
            dots: true,
            fade: true,
            slidesToScroll: 1
        }
    },
    bonusImageCarousel: {
        selector: '#chooseBonusProductModal .carousel.main',
        settings: {
            infinite: false,
            slidesToShow: 1,
            dots: false,
            fade: true,
            slidesToScroll: 1
        }
    },
    quickViewImageCarousel: {
        selector: '#quickViewModal .primary-images .carousel.main',
        settings: {
            infinite: false,
            slidesToShow: 1,
            dots: true,
            fade: true,
            slidesToScroll: 1
        }
    },
    productTileCarousel: {
        selector: '.product-listing.slider',
        settings: {
            slidesToShow: 2,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: globalConfig.bp.small,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 2
                    }
                },
                {
                    breakpoint: globalConfig.bp.large,
                    settings: {
                        slidesToShow: 4,
                        slidesToScroll: 3
                    }
                }
            ]
        }
    },
    headerBannerCarousel: {
        selector: '.carousel.page-builder',
        settings: {
            infinite: false
        }
    },
    imageZoomCarousel: {
        selector: '.carousel.image-zoom',
        settings: {
            infinite: false,
            slidesToShow: 1,
            fade: true,
            slidesToScroll: 1,
            dots: false
        }
    }
};
